import React from "react";
import "../../assets/css/app.scss";
import Logo from "../../assets/images/logo_white.svg";
import { useType } from "../../hooks/use-type";
import Shindan from "../shindan";
import classNames from "classnames";

export const Main: React.FC = () => {
  const type = useType();
  return (
    <div className={classNames("wrapper", type)}>
      <div className="shindan-app">
        <div className="shindan-app__logo">
          <a
            className="hover--opacity"
            href={`${process.env.REACT_APP_ORIGIN}/shindan`}
          >
            <img src={Logo} alt="COCOLOR" />
          </a>
        </div>

        <Shindan />

        <p className="shindan-app__copyright">
          Copyright &copy; COCOLOR/Yae Totokawa All Rights Reserved.
        </p>
      </div>
    </div>
  );
};
